"use client"

import React from 'react';
import styles from "./Blessings.module.scss";
import {useAppStore} from "@/store/AppStore";
import {Liturgy} from "@/types/Liturgies";
import useBlessingsData from "@/utils/hooks/useBlessingsData";
import LoginAlert from "@/components/LoginAlert/LoginAlert";

export default function Blessings(params: { currentId?: string }) {
  const {currentId} = params
  const user = useAppStore((state) => state.user);
  const data = useBlessingsData(user?.access_token)
  const items = data?.items

  // `opened` deriva da `currentId` (formato `blessing-<id>`).
  const opened = currentId?.includes("blessing")
    ? Number(currentId.split("blessing-")[1])
    : undefined

  if (!currentId) return null
  if (!currentId.includes("blessing")) return null
  if (!user) return <LoginAlert/>

  const actives: Liturgy[] | undefined = opened ? items?.filter((itm) => {
    return itm.id === opened
  }) : undefined

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.contentWrapper}>
          {actives && actives.at(0) && <div>
            <h2 className={styles.prayerTitle}>{actives?.at(0)?.name}</h2>
            <div dangerouslySetInnerHTML={{__html: String(actives?.at(0)?.content)}}/>
          </div>
          }
        </div>
      </div>
    </div>
  )
}
